import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Spin, Table, Input, Select } from 'antd';
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message';

const { Option } = Select;

const SelectStudentModal = (props) => {

    const messageRef = useRef();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0); //总条数
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({
        activeInd: "Y"
    });
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [progModel, setProgModel] = useState(props.progModel);
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        search(pageSize, 1, "N");
        setCheckboxState(props.checkboxState);
    }, []);

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        messageShowHandler();  // 清除提示信息
        clearSelect(); // 清除选中状态
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.pageSize = pageSizeNew;
        model.progId = progModel.progId
        model.cohortYear = Config.cohort?.cohortYear
        setIsLoad(true);
        Base.callBackApi("jobPost/searchStudent", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({
            activeInd: "Y"
        });
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const save = () => {
        if(checkboxState == null || checkboxState.length == 0) {
            errFrameShow("error", trans.pleaseSelectAtLeastOneRecord[Config.backLang]);
            return;
        }
        props.onClose(true, checkboxState);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style);
        messageRef.current.setContent(msg);
        messageRef.current.setIsShow(true);
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    }

    const columns = [
        {
            title: "Student ID",
            dataIndex: 'studentAcctId',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: "Student Name",
            dataIndex: 'firstName',
            className: 'tableWidth25',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'firstName') },
            render: (text, record) => <div>{text + " " + record.lastName}</div>
        },
        {
            title: "email",
            dataIndex: 'email',
            className: 'tableWidth20',
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth15',
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth20',
            render: text => text ? moment(text).format(Config.dateFormat5) : '',
        },
    ];
    return (
        <Modal className="selectStudentModal"
            visible={true}
            title="Select Student"//标题
            centered//垂直居中
            closable//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭    
            width={'952px'}
            onCancel={() => props.onClose(false)}
            footer={[
                <Button key='save' className='sysBtn btnBlue' type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.select[Config.backLang]}</Button>, 
                <Button key='cancel' className="sysBtn" onClick={() => props.onClose(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
            ]}
        >
            <Spin size="large" spinning={isLoad} tip={trans.beQuerying[Config.backLang]}>
                <Message ref={messageRef} />
                <div className='sysSearchRow'>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitle">Student ID</div>
                            <div className="sysSerchInput">
                                <Input type="text" placeholder="Student ID"
                                    onChange={(e) => searchChange('studentAcctId', e.target.value)}
                                    value={searchModel.studentAcctId || ''} />
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Student Name</div>
                            <div className="sysSerchInput">
                                <Input type="text" placeholder="Student Name"
                                    onChange={(e) => searchChange('studentName', e.target.value)}
                                    value={searchModel.studentName || ''} />
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">Status</div>
                            <div className="sysSerchInput">
                                <Select className="sysSelect" placeholder="Status"
                                    value={searchModel.activeInd || ''}
                                    onChange={(e) => searchChange('activeInd', e)}
                                >
                                    <Option value=""></Option>
                                    {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                </Select>
                            </div>
                        </div>
                        <div className='sysSearchButton'>
                            <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                        </div>

                    </div>
                </div>
                <div className="sysLineEight"></div>
                <div className="sysTable" id="tableOne">
                    <Table
                        rowSelection={rowSelection}
                        scroll={{ x: 800 }}
                        rowKey="assignToUserId" //Key值
                        columns={columns} //列名
                        dataSource={tables} //数据
                        pagination={{  //分页
                            showSizeChanger: true,    //是否显示可以设置几条一页的选项
                            onChange: onChange,       //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange, //每页显示条数方法
                            total: tablesCount,        //总共多少条数据
                            current: current,       //当前页
                            pageSize: pageSize,  //每页显示多少条数据
                            defaultCurrent: 1, //默认当前页为1
                            size: "small"
                        }}
                        onRow={(record) => {
                            return {
                                onClick: event => Base.selectRowNew.call(this, record, 'assignToUserId', checkboxState, selectedRowKeys, setCheckboxState, setSelectedRowKeys),
                            };
                        }}
                    />
                </div>
            </Spin>
        </Modal>
    )

}

SelectStudentModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    checkboxState: PropTypes.array,
    progModel: PropTypes.object,
}

export default SelectStudentModal;